@if (showMobileGate()) {
    <mobile-gate></mobile-gate>
} @else {
    <router-outlet></router-outlet>
    <ra-upload-progress-bar></ra-upload-progress-bar>
    <ra-toast></ra-toast>
}

<!-- A trava pode chegar depois da abertura (onboarding no celular termina em /platform). -->
@if (showSplash() && !showMobileGate()) {
    <splash-screen [ready]="bootstrapDone()" (done)="showSplash.set(false)"></splash-screen>
}
